import BaseCadastro from "components/BaseCadastro";
import { Label } from "components/input/Label";
import CondicaoPagamento from "model/fiscal/CondicaoPagamento";
import CondicaoPagamentoParcela from "model/fiscal/CondicaoPagamentoParcela";
import FormaPagamento from "model/fiscal/FormaPagamento";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import CondicaoPagamentoService from "service/fiscal/CondicaoPagamentoService";
import FormaPagamentoService from "service/fiscal/FormaPagamentoService";

const condicaoPagamentoService = new CondicaoPagamentoService();
const formaPagamentoService = new FormaPagamentoService();

export default function CondicaoPagamentoCadastro() {
    const [condicaoPagamento, setCondicaoPagamento] = useState(new CondicaoPagamento());
    const [formasPagamento, setFormasPagamento] = useState<FormaPagamento[]>([]);
    const [erro, setErro] = useState("");
    const [parcelaEdicao, setParcelaEdicao] = useState<CondicaoPagamentoParcela | null>(null);
    const [indiceParcelaEdicao, setIndiceParcelaEdicao] = useState<number | null>(null);
    const [erroParcela, setErroParcela] = useState("");

    useEffect(() => {
        formaPagamentoService.getAll()
            .then(setFormasPagamento)
            .catch(error => console.error("Erro ao buscar formas de pagamento:", error));
    }, []);

    function alterarParcela(changes: Partial<CondicaoPagamentoParcela>) {
        setParcelaEdicao(atual => atual ? { ...atual, ...changes } : null);
        setErroParcela("");
    }

    function adicionarParcela() {
        const sequencia = Math.max(0, ...condicaoPagamento.parcelas.map(item => item.sequencia)) + 1;
        setIndiceParcelaEdicao(null);
        setErroParcela("");
        setParcelaEdicao(new CondicaoPagamentoParcela(
            null, null, sequencia, 1, 0, 0, null, null, 100
        ));
    }

    function editarParcela(parcela: CondicaoPagamentoParcela) {
        setIndiceParcelaEdicao(condicaoPagamento.parcelas.indexOf(parcela));
        setErroParcela("");
        setParcelaEdicao({ ...parcela });
    }

    function fecharModalParcela() {
        setParcelaEdicao(null);
        setIndiceParcelaEdicao(null);
        setErroParcela("");
    }

    function salvarParcela() {
        if (!parcelaEdicao) return;
        if (parcelaEdicao.quantidadeParcelas < 1 || parcelaEdicao.diasPrimeiroVencimento < 0 ||
            parcelaEdicao.diasEntreParcelas < 0 || parcelaEdicao.percentualRateio <= 0 ||
            parcelaEdicao.percentualRateio > 100) {
            setErroParcela("Confira a quantidade, os prazos e o percentual da parcela.");
            return;
        }
        const parcelas = [...condicaoPagamento.parcelas];
        if (indiceParcelaEdicao === null) {
            parcelas.push(parcelaEdicao);
        } else {
            parcelas[indiceParcelaEdicao] = parcelaEdicao;
        }
        setCondicaoPagamento({ ...condicaoPagamento, parcelas });
        setErro("");
        fecharModalParcela();
    }

    function removerParcela(index: number) {
        setCondicaoPagamento({
            ...condicaoPagamento,
            parcelas: condicaoPagamento.parcelas.filter((_, itemIndex) => itemIndex !== index)
        });
    }

    function validar() {
        if (!condicaoPagamento.codigoInterno || !condicaoPagamento.descricao) {
            setErro("Informe o código e a descrição.");
            return false;
        }
        if (!condicaoPagamento.parcelas.length) {
            setErro("Inclua ao menos uma parcela.");
            return false;
        }
        if (condicaoPagamento.parcelas.some(item =>
            item.quantidadeParcelas < 1 || item.diasPrimeiroVencimento < 0 ||
            item.diasEntreParcelas < 0 || item.percentualRateio <= 0 ||
            item.percentualRateio > 100)) {
            setErro("Confira a quantidade, os prazos e o percentual das parcelas.");
            return false;
        }
        const totalRateio = condicaoPagamento.parcelas.reduce((total, item) => total + item.percentualRateio, 0);
        if (Math.abs(totalRateio - 100) > 0.0001) {
            setErro("A soma dos percentuais de rateio deve ser 100%.");
            return false;
        }
        setErro("");
        return true;
    }

    return (
        <BaseCadastro model={condicaoPagamento} service={condicaoPagamentoService}
            setModel={(value: CondicaoPagamento) => setCondicaoPagamento(value)}
            getNewModel={() => new CondicaoPagamento()} novoCadastro
            validar={validar} pathCadastro="/condicaoPagamento" urlService="/condicaoPagamento"
            tituloPagina="Condição de pagamento">
            <div className="row">
                <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">Condição de pagamento</label>
            </div>
            <div className="row">
                <div className="col-12 mb-3">
                    <Checkbox inputId="condicao-ativa" checked={condicaoPagamento.ativa}
                        onChange={(e) => setCondicaoPagamento({ ...condicaoPagamento, ativa: !!e.checked })} />
                    <label htmlFor="condicao-ativa" style={{ marginLeft: 8 }}>Ativa</label>
                </div>
                <div className="col-12 mb-3">
                    <Label obrigatorio>Código</Label>
                    <InputText value={condicaoPagamento.codigoInterno} maxLength={6}
                        onChange={(e) => setCondicaoPagamento({ ...condicaoPagamento, codigoInterno: e.target.value })}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label obrigatorio>Descrição</Label>
                    <InputText value={condicaoPagamento.descricao} maxLength={50}
                        onChange={(e) => setCondicaoPagamento({ ...condicaoPagamento, descricao: e.target.value })}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>Abreviatura</Label>
                    <InputText value={condicaoPagamento.abreviatura ?? ""} maxLength={10}
                        onChange={(e) => setCondicaoPagamento({ ...condicaoPagamento, abreviatura: e.target.value })}
                        style={{ width: "100%" }} />
                </div>
            </div>
            
            <DataTable value={condicaoPagamento.parcelas} scrollable
                emptyMessage="Nenhuma parcela adicionada"
                header={<div className="d-flex justify-content-between align-items-center">
                    <Label>Parcelas</Label>
                    <Button type="button" label="Adicionar parcela" icon="pi pi-plus" onClick={adicionarParcela} />
                </div>} >
                <Column field="sequencia" header="Sequência" />
                <Column field="quantidadeParcelas" header="Qtd. parcelas" />
                <Column field="diasPrimeiroVencimento" header="Primeiro vencimento (dias)" />
                <Column field="diasEntreParcelas" header="Entre parcelas (dias)" />
                <Column header="Dia fixo do mês"
                    body={(parcela: CondicaoPagamentoParcela) => parcela.diaFixoMes ?? "—"} />
                <Column header="Rateio (%)"
                    body={(parcela: CondicaoPagamentoParcela) => parcela.percentualRateio.toLocaleString("pt-BR", { maximumFractionDigits: 4 })} />
                <Column header="Forma de pagamento"
                    body={(parcela: CondicaoPagamentoParcela) => parcela.formaPagamento?.descricao ?? "—"} />
                <Column header="Ações" body={(parcela: CondicaoPagamentoParcela) => (
                    <div className="d-flex gap-2">
                        <Button type="button" label="Editar" icon="pi pi-pencil"
                            onClick={() => editarParcela(parcela)} />
                        <Button type="button" label="Remover" icon="pi pi-trash" severity="danger"
                            onClick={() => removerParcela(condicaoPagamento.parcelas.indexOf(parcela))} />
                    </div>
                )} />
            </DataTable>
            <Dialog visible={parcelaEdicao !== null} onHide={fecharModalParcela}
                header={indiceParcelaEdicao === null ? "Adicionar parcela" : "Editar parcela"}
                style={{ width: "600px" }} breakpoints={{ '960px': '75vw', '641px': '95vw' }}
                footer={(
                    <div className="d-flex justify-content-end gap-2">
                        <Button type="button" label="Cancelar" onClick={fecharModalParcela} />
                        <Button type="button" label="Confirmar" icon="pi pi-check" onClick={salvarParcela} />
                    </div>
                )}>
                {parcelaEdicao && (
                    <div className="row">
                        <div className="col-12 mb-2">
                            <Label>Sequência</Label>
                            <InputNumber value={parcelaEdicao.sequencia} disabled style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 mb-2">
                            <Label obrigatorio>Qtd. parcelas</Label>
                            <InputNumber value={parcelaEdicao.quantidadeParcelas} min={1} useGrouping={false}
                                onValueChange={(e) => alterarParcela({ quantidadeParcelas: e.value ?? 1 })}
                                style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 mb-2">
                            <Label obrigatorio>Primeiro vencimento (dias)</Label>
                            <InputNumber value={parcelaEdicao.diasPrimeiroVencimento} min={0} useGrouping={false}
                                onValueChange={(e) => alterarParcela({ diasPrimeiroVencimento: e.value ?? 0 })}
                                style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 mb-2">
                            <Label>Entre parcelas (dias)</Label>
                            <InputNumber value={parcelaEdicao.diasEntreParcelas} min={0} useGrouping={false}
                                onValueChange={(e) => alterarParcela({ diasEntreParcelas: e.value ?? 0 })}
                                style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 mb-2">
                            <Label>Dia fixo do mês</Label>
                            <InputNumber value={parcelaEdicao.diaFixoMes} min={1} max={31} useGrouping={false}
                                onValueChange={(e) => alterarParcela({ diaFixoMes: e.value })}
                                style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 mb-2">
                            <Label obrigatorio>Rateio (%)</Label>
                            <InputNumber value={parcelaEdicao.percentualRateio} min={0.0001} max={100} maxFractionDigits={4}
                                onValueChange={(e) => alterarParcela({ percentualRateio: e.value ?? 0 })}
                                style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 mb-2">
                            <Label>Forma de pagamento</Label>
                            <Dropdown value={parcelaEdicao.formaPagamento?.id ?? null} options={formasPagamento}
                                optionLabel="descricao" optionValue="id" showClear
                                onChange={(e) => alterarParcela({
                                    formaPagamento: formasPagamento.find(item => item.id === e.value) ?? null
                                })}
                                style={{ width: "100%" }} />
                        </div>
                        {erroParcela && <small className="p-error" role="alert">{erroParcela}</small>}
                    </div>
                )}
            </Dialog>
            {erro && <small className="p-error">{erro}</small>}
        </BaseCadastro>
    );
}
